// extracted by mini-css-extract-plugin
export default {"textareaContainer":"textareaContainer__G5g27","imageCard":"imageCard__PHZWD","imageContainer":"imageContainer__GjBUl","textarea":"textarea__S9vnw"};